import React from 'react';
import {Button} from 'antd';

import classnames from 'classnames'

class CkDockPanel extends React.Component {

    constructor(props) {
        super(props);

    }

    componentWillReceiveProps(nextProps) {
        /* const {collapsed} = nextProps;
         if (collapsed != null) {
             this.setState({
                 collapsed: collapsed
             })
         }*/
    }

    componentDidMount() {

    }

    collapsePanel = () => {
        this.props.onCollapse()
    }

    render() {

        /*var testExtra = <Row>
            <Col span={8}>
                <div className="ck-info-item" style={{width: "100%"}}>
                    <div className="ck-info-item-label "><label for="pane" title="客户">客户</label></div>
                    <Row type="flex">
                        <div className="col-flex-primary ck-info-item-field "><span>山特维克矿山工程机械贸易(上海)有限公司</span></div>
                    </Row>
                </div>
            </Col>
            <Col span={6}>
                <div className="ck-info-item" style={{width: "100%"}}>
                    <div className="ck-info-item-label "><label for="pane" title="提运单号">提运单号</label></div>
                    <Row type="flex">
                        <div className="col-flex-primary ck-info-item-field "><span></span></div>
                    </Row>
                </div>
            </Col>
            <Col span={6}>
                <div className="ck-info-item" style={{width: "100%"}}>
                    <div className="ck-info-item-label "><label for="pane" title="订单号">订单号</label></div>
                    <Row type="flex">
                        <div className="col-flex-primary ck-info-item-field "><span>N05001171518-1</span></div>
                    </Row>
                </div>
            </Col>
            <Col span={4}>
                <div className="ck-info-item" style={{width: "100%"}}>
                    <div className="ck-info-item-label ">
                        <label for="pane" title="委托日期">委托日期</label>
                    </div>
                    <Row type="flex">
                        <div className="col-flex-primary ck-info-item-field ">
                            <span><span className="ck-info-item-addon-before"><Icon type={"anticon-calendar"}/></span>2017.11.02</span>
                        </div>
                    </Row>


                </div>
            </Col>
        </Row>*/

        /* var testOverlayMenu = <div className="ck-dock-panel-popover">
             <Menu>
                 <Menu.Item key="c1">
                     <Icon type="user"/>
                     冻结
                 </Menu.Item>
             </Menu>
         </div>*/


        var extra = this.props.extra ?
            <div className="ck-dock-panel-head-extra">{this.props.extra}</div>
            : null


        var overlay = this.props.overlayMenu ?
            <div className="ck-dock-panel-head-overlay">
                {this.props.overlayMenu}
                {/*<Popover placement="bottomRight" title={"更多操作"} content={} trigger="click">
                    <Button shape="circle" icon="ellipsis"/>
                </Popover>*/}
            </div>
            : null

        const {size} = this.props;
        return (
            <div className={this.props.className}>
                <div className={classnames("ck-dock-panel-mask", {"ck-dock-panel-mask-hidden": this.props.collapsed})} onClick={this.collapsePanel}></div>
                <div className={classnames("ck-dock-panel", `ck-dock-panel-${size}`, {"ck-dock-panel-visible": !this.props.collapsed})} style={this.props.style}>
                    <div className="ck-dock-panel-head">
                        <div className="ck-dock-panel-head-title">
                            {this.props.title}
                            {this.props.extraStatus}

                            {overlay}
                            <div className="ck-dock-panel-head-close">
                                <Button  icon="close" onClick={this.collapsePanel}/>
                            </div>
                        </div>
                        {extra}
                    </div>
                    <div className="ck-dock-panel-body" style={this.props.ckDockPanelBodyStyle}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}


CkDockPanel.contextTypes = {};

CkDockPanel.defaultProps = {
    overlayMenu: null,
    size: "default",
    title: "",
    collapsed: true,
    extra: null,
    extraStatus: null,
    ckDockPanelBodyStyle: null,
    onCollapse: () => null
};

CkDockPanel.propTypes = {}


export default CkDockPanel;


// WEBPACK FOOTER //
// ./src/components/CkDockPanel.jsx